import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DecimalDirective } from './decimal.directive';
import { AlphanumericDirective } from './alpha-numeric.directive';
import { NumberCustomDirective } from './number-custom.directive';
import { NumericDirective } from './numeric.directive';
import { UppercaseDirective } from './uppercase.directive';

@NgModule({
  declarations: [
    AlphanumericDirective,
    DecimalDirective,
    NumericDirective,
    UppercaseDirective,
    NumberCustomDirective
  ],
  imports: [CommonModule],
  exports: [
    AlphanumericDirective,
    DecimalDirective,
    NumericDirective,
    UppercaseDirective,
    NumberCustomDirective
  ]
})
export class DirectivesModule { }
